import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {Backend, PERMISSION} from '@generated-backend-types';
import {ToastrService} from 'ngx-toastr';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {BsModalRef, BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import Author = Backend.App.Resources.Dashboard.Administration.Author;
import Publication = Backend.App.Resources.Dashboard.Administration.Publication;
import AuthorTypeEnum = Backend.App.Enums.AuthorTypeEnum;
import {
  ReadOnlyStaticComponent
} from '../../../../../../components/form-inputs/read-only-static/read-only-static.component';
import {IfHasAllPermissionsDirective} from '../../../../../../directives/if-has-all-permissions.directive';
import {AuthorService} from '../../../../../../services/api/administration/author.service';
import {UserSessionService} from '../../../../../../services/user-session.service';

@Component({
  selector: 'app-authenticated-administration-publications-authors-show',
  templateUrl: './show.component.html',
  imports: [
    ReadOnlyStaticComponent,
    TranslatePipe,
    ModalModule,
    IfHasAllPermissionsDirective,
  ],
  providers: [BsModalService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShowComponent {
  @Input({required: true}) public publication!: Publication;
  @Input({required: true}) public author!: Author;
  @Output() public authorDeleted = new EventEmitter<void>();
  @ViewChild('confirmModal') public confirmModal!: TemplateRef<never>;
  public confirmModalRef?: BsModalRef;
  protected readonly AuthorTypeEnum = AuthorTypeEnum;

  public constructor(
    private readonly authorService: AuthorService,
    private readonly toastrService: ToastrService,
    private readonly translate: TranslateService,
    private readonly bsModalService: BsModalService,
    private readonly userSessionService: UserSessionService,
  ) {
  }

  public delete() {
    if (!this.userSessionService.hasAllPermission([PERMISSION.ADMINISTRATION_AUTHOR_DELETE_ALL])) {
      this.toastrService.error(this.translate.instant('misc.not_enough_permissions_error'));
    } else {
      this.confirmModalRef = this.bsModalService.show(this.confirmModal);
    }
  }

  public confirmDelete() {
    if (this.author) {
      this.authorService.delete(this.author.id).subscribe({
        next: () => {
          this.toastrService.success(this.translate.instant('authenticated.administration.publications.edit.authors.delete.success'));
          this.authorDeleted.emit();
        },
        complete: () => this.confirmModalRef?.hide()
      });
    }
  }

  protected readonly PERMISSION = PERMISSION;
}
